<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editCollection="selected"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :access="checkRightStatus(8)"
        title="Collections"
        :color="$style.purchase.titlebar"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-flex shrink>
          <v-switch
            color="yellow darken-1"
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
          ></v-switch>
        </v-flex> -->
      </v-card-title>
      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="collections"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">
              {{ item.name }}
            </td>
            <!-- <td class="text-left">
              {{ item.productBalance }}
            </td>
            <td class="text-left">
              {{ item.note }}
            </td> -->
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(24)"
                    @click="editCollection(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(8)"
                    @click="deleteCollection(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import collectionService from "@/modules/Product/Collection/service.js";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "Collection-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selected: null,
      expanded: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "",
          width: "50px",
          value: "action",
          sortable: false,
        },
      ],
      collections: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "smplsale - Collection";
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      return collectionService.getAll().then((response) => {
        this.loading = false;
        // console.log("collections", response);
        this.collections = response.data;
        return response;
      });
    },
    editCollection(Collection) {
      this.selected = Collection;
      this.editDialog = !this.editDialog;
    },
    deleteCollection(Collection) {
      if (Collection.productCount > 0) {
        this.$swal({
          title: "Delete Collection",
          text: `${Collection.name} is used in ${Collection.productCount} product(s) change from product before you delete this Collection`,
          icon: "warning",
        });
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            collectionService.delete(Collection.id).then((response) => {
              if (response.data) {
                this.$swal(
                  "Deleted!",
                  "Collection has been deleted.",
                  "success"
                );
                this.getList();
              }
            });
          }
        });
      }
    },
  },
};
</script>
